module.exports = __webpack_public_path__ + "img/zhujian.asm.fca9070a.jpg";